<div class="grid-container padding-y-2">
  <div>
    <tabset #tabset>
      <tab heading="HHG View Rates" id="tab1" (selectTab)="onSelectTab($event)">
        @if (this.activeTab === 'zero' || showViewRate) {
          <app-hhg-rates-download></app-hhg-rates-download>
        }
      </tab>
      <tab heading="HHG Add Rates" id="tab2" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
        @if (this.activeTab === 'one') {
          <app-hhg-carrier-rate-filing></app-hhg-carrier-rate-filing>
        }
      </tab>
      <tab heading="HHG Edit Rates" id="tab3" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
        @if (this.activeTab === 'two') {
          <app-hhg-rate-edit></app-hhg-rate-edit>
        }
      </tab>
      <tab heading="HHG Global Update" id="tab4" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
        @if (this.activeTab === 'three') {
          <app-hhg-rate-global-update></app-hhg-rate-global-update>
        }
      </tab>
      <tab heading="HHG Upload Rate File" id="tab5" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
        <!-- <app-upload *ngIf="this.activeTab === 'four'" [businessType]="'hhg'"></app-upload> -->
        @if (this.activeTab === 'four') {
          <app-hhg-rates-upload></app-hhg-rates-upload>
        }
      </tab>
      <tab heading="HHG Template Download" id="tab6" (selectTab)="onSelectTab($event)">
        @if (this.activeTab === 'five') {
          <app-hhg-template-download></app-hhg-template-download>
        }
      </tab>
    </tabset>
  </div>
</div>